import { PCont } from "./Personal.styles.js";
import { SubNameTxt } from "./SubName.styles.js";

const SubName = () => {
  return (
    <PCont>
      <SubNameTxt>Web developer & Pixel Artist</SubNameTxt>
    </PCont>
  );
};

export default SubName;
